module.exports = __webpack_public_path__ + "img/icon-pushpin.e596120f.svg";